import layout from '@/layout'

export default {
  path: '/application',
  component: layout,
  redirect: '/application/web',
  name: 'branchInfo',
  meta: {
    title: '应用管理',
    icon: 'application'
  },
  children: [
    {
      path: '/application/web',
      // redirect: '/application/mobile?type=1',
      component: () => import('@/views/application/authModule'),
      meta: {
        title: 'web应用',
        icon: 'application-one'
      }
    }
    // {
    //   path: '/application/mobile/:id',
    //   component: () => import('@/views/application/authModule/info'),
    //   meta: {
    //     title: '移动应用详情'
    //   }
    // }
  ]
}
